import CopyText from 'components/CopyText';
import EllipsisText from 'components/EllipsisText';
import MentorshipStatusChip from 'components/Chips/MentorshipStatusChip';
import List from 'components/list';
import { BoldTd, Td } from 'components/list/Td';
import { getOrderTh, Th } from 'components/list/Th';
import React, { FC, useContext } from 'react';
import { Link } from 'react-router-dom';
import { getLocaleDate } from 'utils/time';
import { BinomesContext, sortableColumns } from '..';

const OrderTh = getOrderTh<typeof sortableColumns[number]>();

const binomeColumns = {
  mentee: true,
  mentor: true,
  createdAt: true,
  status: true,
  referee: true,
  menteeEmail: true,
  mentorEmail: true,
};

const BinomesList: FC = () => {
  const { binomes, pages, page, setPage, loading, order, setOrder } =
    useContext(BinomesContext);

  return (
    <List
      activeColumns={binomeColumns}
      columnNumber={7}
      isEmpty={binomes?.length === 0}
      emptyText="Aucun binôme n'est disponible pour cette recherche"
      pages={pages}
      page={page}
      setPage={setPage}
      loading={loading}
    >
      <Th name="mentee">Mentoré</Th>
      <Th name="mentor">Mentor</Th>
      <OrderTh name="createdAt" order={order} setOrder={setOrder}>
        Date de matching
      </OrderTh>
      <OrderTh name="status" order={order} setOrder={setOrder}>
        Statut du mentorat
      </OrderTh>
      <Th name="referee">Chargé(e) de mentorat</Th>
      <Th name="menteeEmail">Email mentoré</Th>
      <Th name="mentorEmail">Email mentor</Th>

      {binomes?.map((binome, idx) => (
        <React.Fragment key={idx}>
          <BoldTd name="mentee">
            <Link to={`/admin/mentoring/mentees/${binome.mentee.id}/`}>
              <EllipsisText
                text={`${binome.mentee.firstName} ${binome.mentee.lastName}`}
              />
            </Link>
          </BoldTd>
          <BoldTd name="mentor">
            <Link to={`/admin/mentoring/mentors/${binome.mentor.id}/`}>
              <EllipsisText
                text={`${binome.mentor.firstName} ${binome.mentor.lastName}`}
              />
            </Link>
          </BoldTd>
          <Td name="createdAt">{getLocaleDate(binome.createdAt)}</Td>
          <Td name="status">
            <MentorshipStatusChip status={binome.status} />
          </Td>
          <Td name="referee">{binome.referee?.name || ''}</Td>
          <Td name="menteeEmail">
            <EllipsisText text={binome.mentee.email} />
            <CopyText text="" copiedText={binome.mentee.email} />
          </Td>
          <Td name="mentorEmail">
            <EllipsisText text={binome.mentor.email} />
            <CopyText text="" copiedText={binome.mentor.email} />
          </Td>
        </React.Fragment>
      ))}
    </List>
  );
};

export default BinomesList;